(function () {
  'use strict';

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function initReveal(section) {
    var items = section.querySelectorAll('[data-wi-item]');
    if (!items.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (el) { io.observe(el); });
  }

  function initScrollJack(section) {
    var track = section.querySelector('[data-wi-track]');
    var viewport = section.querySelector('[data-wi-viewport]');
    var frame = section.querySelector('[data-wi-frame]');
    var list = section.querySelector('[data-wi-list]');
    if (!track || !viewport || !frame || !list) return;

    var raf = 0;
    var lastProgress = -1;

    function compute() {
      raf = 0;
      if (!isDesktop()) {
        list.style.transform = '';
        return;
      }

      var listHeight = list.scrollHeight;
      var frameHeight = frame.clientHeight;
      var maxOffset = Math.max(0, listHeight - frameHeight);

      if (Math.abs(maxOffset - parseFloat(track.dataset.wiOffset || -1)) > 1) {
        track.dataset.wiOffset = maxOffset;
        track.style.setProperty('--wi-scroll-distance', maxOffset + 'px');
      }

      var rect = track.getBoundingClientRect();
      var scrollDistance = track.offsetHeight - viewport.offsetHeight;
      if (scrollDistance <= 0) {
        list.style.transform = 'translate3d(0,0,0)';
        return;
      }

      var scrolled = -rect.top;
      var progress = Math.max(0, Math.min(1, scrolled / scrollDistance));

      if (Math.abs(progress - lastProgress) < 0.001) return;
      lastProgress = progress;

      list.style.transform = 'translate3d(0,' + (-(maxOffset * progress)).toFixed(2) + 'px,0)';
    }

    function schedule() {
      if (raf) return;
      raf = window.requestAnimationFrame(compute);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    compute();
  }

  function init(section) {
    initReveal(section);
    if (!prefersReduced) initScrollJack(section);
  }

  function boot() {
    document
      .querySelectorAll('[data-section-type="whats-included"]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-section-type="whats-included"]');
    if (sec) init(sec);
  });
})();
